import * as React from "react";

;
export const Forward = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="#585265" {...props}><path d="M9.96 8 4.313 2.354l.708-.708L11.374 8l-6.353 6.354-.708-.707L9.96 8Z" /></svg>;